import {Component} from '@angular/core';
import {ProgressSpinnerMode} from '@angular/material/progress-spinner';
import { MatDialogRef} from '@angular/material/dialog'; 
import {ThemePalette} from '@angular/material/core';


@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
})
export class SpinnerComponent {
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  value = 80;
  constructor(public dialogRef: MatDialogRef<SpinnerComponent>) {}  
}
